import uuid from 'uuid';

export const CREATE_NEW_RESPONSE = "CREATE_NEW_RESPONSE";
export function createNewResponse(attrs, callback) {
  return (dispatch, getState) => {
    let auth = getState().auth;
    let response = {
      name: auth.name,
      email: auth.email,
      organization: auth.organization,
      ...attrs,
      metadata: {
        id: uuid.v4()
      },
      answers: {}
    }
    dispatch({
      type: CREATE_NEW_RESPONSE,
      response
    });
    callback(response);
  }
}
